import axios from "axios";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import Select from "react-select";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import MiniGraficoAsistenacial from "./MiniGraficoAsistencial";

const axiosInstance = axios.create({
  baseURL: "https://suadesarrollo.azurewebsites.net/api",
  auth: {
    username: "BasicAuth@icontec.org",
    password: "yQLzqmR7eZSuAmQZUqhY",
  },
});

function IndicadorAsistencial({ solicitudId }) {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [list, setList] = useState([]);

  // 🔹 Obtener listado de indicadores
  const fetchOptions = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get("/ObtieneListadoIndicadores");

      const formatted = data
        .filter((item) => item.origen !== "A10")
        .map((item) => ({
          value: item.codigo,
          label: `${item.nombreIndicador} - Código: ${item.codigo}`,
          grupo: item.origen,
        }));

      setOptions(formatted);
    } catch (error) {
      console.error("Error cargando indicadores:", error);
    }
  }, []);

  // 🔹 Obtener priorizados
  const fetchData = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(
        `/ObtenerPriorizados/${solicitudId}`,
      );

      setList(data.filter((item) => item.grupo !== "A10"));
    } catch (error) {
      console.error("Error cargando priorizados:", error);
    }
  }, [solicitudId]);

  // 🔹 Priorizar indicadores (OPTIMIZADO 🔥)
  const postData = async (e) => {
    e.preventDefault();

    if (!selectedOptions?.length) {
      alert("Seleccione al menos un indicador");
      return;
    }

    try {
      await Promise.all(
        selectedOptions.map((item) =>
          axiosInstance.get(
            `/PriorizaIndicadoresA/${solicitudId}/${item.value}/${item.grupo}`,
          ),
        ),
      );

      alert("Indicadores priorizados correctamente");
      fetchData();
    } catch (error) {
      console.error(error);
      alert("Error al priorizar indicadores");
    }
  };

  // 🔹 Carga inicial
  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  // 🔹 Intervalo optimizado
  useEffect(() => {
    fetchData();

    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, [fetchData]);

  // 🔹 Columnas memoizadas
  const columns = useMemo(
    () => [
      { Header: "Código", accessor: "codigo" },
      { Header: "Nombre del Indicador", accessor: "nombreIndicador" },
      { Header: "Grupo", accessor: "grupo" },
    ],
    [],
  );

  // 🔹 Tabla
  const tableInstance = useTable(
    {
      columns,
      data: list || [],
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  } = tableInstance;

  return (
    <div className="container">
      <h6 className="m-0 font-weight-bold text-primary">
        Priorizar Indicadores
      </h6>

      <div className="col-sm-12 mb-2">Seleccione el indicador</div>

      <Select
        options={options}
        isMulti
        classNamePrefix="select"
        onChange={setSelectedOptions}
      />

      <br />

      <MiniGraficoAsistenacial solicitud={solicitudId} />

      <div className="card-body">
        <button
          className="btn btn-primary btn-user btn-block"
          onClick={postData}
        >
          Priorizar
        </button>
      </div>

      <div className="table-responsive">
        <table {...getTableProps()} className="table table-bordered">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button onClick={previousPage} disabled={!canPreviousPage}>
          Anterior
        </button>

        <button onClick={nextPage} disabled={!canNextPage}>
          Siguiente
        </button>
      </div>
    </div>
  );
}

export default IndicadorAsistencial;
